import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CasaRestApiV2 {
  constructor(
    private http: HttpClient,
  ) {
  }

  private url(method: string) {
    return `${environment.casaEndpoint}/api/v2${method}`;
  }

  public syncStudent(schoolId: number, studentId: number) {
    return this.http.patch(this.url(`/schools/${schoolId}/students/${studentId}/refresh`), {});
  }

  public clearStudentDeviceShares(schoolId: number, studentId: number) {
    return this.http.delete(this.url(`/schools/${schoolId}/students/${studentId}/cdrm/devices/shares`));
  }

  public syncTeacher(schoolId: number, teacherId: number) {
    return this.http.patch(this.url(`/schools/${schoolId}/teachers/${teacherId}/refresh`), {});
  }

  public clearTeacherDeviceShares(schoolId: number, teacherId: number) {
    return this.http.delete(this.url(`/schools/${schoolId}/teachers/${teacherId}/cdrm/devices/shares`));
  }
}

